import React from 'react'
import { Icon } from 'antd-mobile'

const Loading = _ => 
    <div className='loadingWrapper'>
    	<Icon type='loading' />
    </div>

export default Loading


// WEBPACK FOOTER //
// ./src/components/loading.jsx